import { isValidNonDateObject } from 'utils/isValidObject';

// Recursively filter out falsy values from suggestion payloads.
export function filterSuggestions(obj: unknown): unknown {
  return isValidNonDateObject(obj)
    ? Object.fromEntries(
        Object.entries(obj as Record<string, unknown>)
          .filter(([_, value]) => value !== '' && !!value)
          .map(([key, value]) => [
            key,
            isValidNonDateObject(value) ? filterSuggestions(value) : value,
          ])
      )
    : obj;
}
